import { fetch } from '@/utils/request';

// 订单
const orderIndex = (param, callback) => fetch('/admin/order/index','GET', param, callback);
const orderDetail = (param, callback) => fetch('/admin/order/detail','GET', param, callback);
const orderCancel = (param, callback) => fetch('/admin/order/cancel','POST', param, callback);
const orderDelivery = (param, callback) => fetch('/admin/order/delivery','POST', param, callback);
const orderRefund = (param, callback) => fetch('/admin/order/refund','POST', param, callback);
const orderStatics = (param, callback) => fetch('/admin/order/statics','GET', param, callback);

// 交易
const tradeIndex = (param, callback) => fetch('/admin/trade/index','GET', param, callback);

// 退款
const refundDetail = (param, callback) => fetch('/admin/refund/detail','GET', param, callback); //详情
const refundAgree = (param, callback) => fetch('/admin/refund/agree','POST', param, callback); //退款同意/拒绝
const refundClose = (param, callback) => fetch('/admin/refund/close','POST', param, callback); //关闭退款

// 提现
const withdrawIndex = (param, callback) => fetch('/admin/withdraw/index','GET', param, callback); //列表
const withdrawOpt = (param, callback) => fetch('/admin/withdraw/opt','POST', param, callback); //同意/拒绝

export default {
  orderIndex,
  orderDetail,
  orderCancel,
  orderDelivery,
  orderRefund,
  orderStatics,
  tradeIndex,
  refundDetail,
  refundAgree,
  refundClose,
  withdrawIndex,
  withdrawOpt
}
